import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'secondary' | 'ghost'

const base = 'inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50'

const styles: Record<Variant, string> = {
  primary: 'bg-slate-800 text-white hover:bg-slate-900',
  secondary: 'border border-gray-200 bg-white text-gray-600 hover:bg-gray-50',
  ghost: 'text-gray-500 hover:bg-gray-100 hover:text-gray-800',
}

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
}

export function Button({ variant = 'secondary', className = '', ...rest }: Props) {
  return <button className={`${base} ${styles[variant]} ${className}`} {...rest} />
}
